import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { Table, TableWrapper, CustomText, CustomLabel6 } from '@4beefopag/4bee-fopag-core/dist/atoms';
import styled from 'styled-components';
import { Header } from '../../atoms/Table';
import InvoiceDownloadLine from './InvoiceDownloadLine';

const TableCustom = styled(Table)`
  width: 100%;
`;
const TableWrapperCustom = styled(TableWrapper)`
  padding: 8px 0px;
`;

function ModalBaixarFaturaList({ open, onCancel, invoices, payrollId }) {
  return (
    <Modal
      open={open}
      title="Baixar Faturas"
      onCancel={onCancel}
      closeable={false}
      width={1000}
      footer={null}
    >
      <CustomText color="#656668">Escolha o formato de download do arquivo</CustomText>
      <div>
        <TableWrapperCustom>
          <TableCustom
            background="#f6f7f9"
            borderBottomTh="1px solid #e8e8e8"
            borderBottomTd="1px solid #e8e8e8"
          >
            <thead>
              <tr>
                <Header>
                  <CustomLabel6>Nome</CustomLabel6>
                </Header>
                <Header>
                  <CustomLabel6>ID</CustomLabel6>
                </Header>
                <Header>
                  <CustomLabel6>Emissão</CustomLabel6>
                </Header>
                <Header>
                  <CustomLabel6>Espécie</CustomLabel6>
                </Header>
                <th />
                <th />
                <th />
                <th />
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => (
                <InvoiceDownloadLine invoice={invoice} payrollId={payrollId} />
              ))}
            </tbody>
          </TableCustom>
        </TableWrapperCustom>
      </div>
    </Modal>
  );
}

ModalBaixarFaturaList.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  invoices: PropTypes.arrayOf(PropTypes.shape()),
  payrollId: PropTypes.string.isRequired,
};

ModalBaixarFaturaList.defaultProps = {
  open: false,
  invoices: [{}],
};

export default ModalBaixarFaturaList;
